module.exports = __webpack_public_path__ + "img/fun-dark.89e34c58.svg";